
export const KeyConstant = {
    TODAY : "TODAY",
    YESTERDAY : "YESTERDAY",
    THIS_WEEK : "THIS_WEEK",
    LAST_WEEK : "LAST_WEEK",
    THIS_MONTH : "THIS_MONTH",
    LAST_MONTH : "LAST_MONTH",
    SEVEN_DAYS_AGO : "SEVEN_DAYS_AGO",
    THIRTY_DAYS_AGO : "THIRTY_DAYS_AGO",
    NINETY_DAYS_AGO : "NINETY_DAYS_AGO",
    CUSTOM: "CUSTOM"
}
